import styled from 'styled-components';
import BaseIcon from '../Icon';
export const List = styled.ul`
  list-style-type: none;
  padding-left: 3rem;
`;
export const Icon = styled(BaseIcon).attrs({
  size: 'small',
  align: 'middle'
})`
  position: absolute;
  line-height: inherit;
  left: -2.5rem;
`;
export const Item = styled.li`
  position: relative;
  margin-bottom: 0.75rem;
`;
//# sourceMappingURL=styles.js.map